module.exports = __webpack_public_path__ + "static/media/check.8b01c2c8.png";